(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/vikinglotto/components/fractiongames/assets/react/fractiongames.js') >= 0) return;  svs.modules.push('/modules/vikinglotto/components/fractiongames/assets/react/fractiongames.js');

'use strict';

const _React = React,
  useEffect = _React.useEffect;
const _ReactRedux = ReactRedux,
  useDispatch = _ReactRedux.useDispatch;
const Games = svs.numbergames.fractiongames.components.Games;
const actions = svs.numbergames.fractiongames.redux.actions;
const Fractiongames = _ref => {
  let productFilter = _ref.productFilter;
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(actions.socketSubscribe());
    return () => {
      dispatch(actions.socketUnsubscribe());
    };
  }, [dispatch]);
  return React.createElement(Games, {
    productFilter: productFilter
  });
};
svs.vikinglotto.components.fractiongames.Fractiongames = Fractiongames;

 })(window);